// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* line 1, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group {
  padding: 6px 15px 6px 15px;
  position: relative;
  max-height: 2000px;
  overflow: hidden;
  transition: max-height 0.218s ease-in-out, padding-top 0.218s ease-in-out, padding-bottom 0.218s ease-in-out;
}
/* line 10, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group:empty {
  display: none;
}
/* line 14, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group > .group-toggle {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 4px;
  cursor: pointer;
  transition: background-color 0.218s linear;
}
/* line 22, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group > .group-toggle:hover {
  background-color: #8fc071;
}
/* line 27, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group > .group-label {
  font-weight: bolder;
  display: inline-block;
  vertical-align: middle;
  color: #666;
  font-size: 120%;
  margin-top: 5px;
  margin-bottom: 10px;
  transition: margin 0.218s linear;
  font-style: italic;
}
/* line 71, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-group > .group-label[for] {
  cursor: pointer;
}
/* line 74, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-group > .group-label.bpp-hidden {
  display: none;
}
/* line 36, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group:hover > .group-toggle {
  background-color: #ccc;
}
/* line 38, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group:hover > .group-toggle:hover {
  background-color: #8fc071;
}
/* line 43, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group.group-closed {
  max-height: 20px;
  border-top: none;
  cursor: pointer;
  background-color: rgba(143, 192, 113, 0.2);
  padding-top: 0;
  padding-bottom: 0;
}
/* line 51, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group.group-closed > div {
  visibility: hidden;
}
/* line 55, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group.group-closed > .group-label {
  margin-top: 2px;
  margin-bottom: 2px;
}
/* line 60, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group.group-closed:hover > .group-label {
  color: #52B415;
}
/* line 65, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group + .bpp-properties-group {
  border-top: 1px dotted #ccc;
}
/* line 69, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */
.bpp-properties-group:last-child {
  padding-bottom: 9px;
}
`, "",{"version":3,"sources":["webpack://./ModuleViews/Administration/BusinessProcesses/css/groups.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4GAA4G;AAC9G;AACA,sEAAsE;AACtE;EACE,aAAa;AACf;AACA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;EACV,eAAe;EACf,0CAA0C;AAC5C;AACA,sEAAsE;AACtE;EACE,yBAAyB;AAC3B;AACA,sEAAsE;AACtE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;AACA,uEAAuE;AACvE;EACE,eAAe;AACjB;AACA,uEAAuE;AACvE;EACE,aAAa;AACf;AACA,sEAAsE;AACtE;EACE,sBAAsB;AACxB;AACA,sEAAsE;AACtE;EACE,yBAAyB;AAC3B;AACA,sEAAsE;AACtE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;AACnB;AACA,sEAAsE;AACtE;EACE,kBAAkB;AACpB;AACA,sEAAsE;AACtE;EACE,eAAe;EACf,kBAAkB;AACpB;AACA,sEAAsE;AACtE;EACE,cAAc;AAChB;AACA,sEAAsE;AACtE;EACE,2BAA2B;AAC7B;AACA,sEAAsE;AACtE;EACE,mBAAmB;AACrB","sourcesContent":["/* line 1, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group {\n  padding: 6px 15px 6px 15px;\n  position: relative;\n  max-height: 2000px;\n  overflow: hidden;\n  transition: max-height 0.218s ease-in-out, padding-top 0.218s ease-in-out, padding-bottom 0.218s ease-in-out;\n}\n/* line 10, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group:empty {\n  display: none;\n}\n/* line 14, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group > .group-toggle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 4px;\n  cursor: pointer;\n  transition: background-color 0.218s linear;\n}\n/* line 22, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group > .group-toggle:hover {\n  background-color: #8fc071;\n}\n/* line 27, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group > .group-label {\n  font-weight: bolder;\n  display: inline-block;\n  vertical-align: middle;\n  color: #666;\n  font-size: 120%;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  transition: margin 0.218s linear;\n  font-style: italic;\n}\n/* line 71, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-group > .group-label[for] {\n  cursor: pointer;\n}\n/* line 74, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-group > .group-label.bpp-hidden {\n  display: none;\n}\n/* line 36, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group:hover > .group-toggle {\n  background-color: #ccc;\n}\n/* line 38, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group:hover > .group-toggle:hover {\n  background-color: #8fc071;\n}\n/* line 43, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group.group-closed {\n  max-height: 20px;\n  border-top: none;\n  cursor: pointer;\n  background-color: rgba(143, 192, 113, 0.2);\n  padding-top: 0;\n  padding-bottom: 0;\n}\n/* line 51, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group.group-closed > div {\n  visibility: hidden;\n}\n/* line 55, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group.group-closed > .group-label {\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n/* line 60, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group.group-closed:hover > .group-label {\n  color: #52B415;\n}\n/* line 65, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group + .bpp-properties-group {\n  border-top: 1px dotted #ccc;\n}\n/* line 69, node_modules\\bpmn-js-properties-panel\\styles\\groups.less */\n.bpp-properties-group:last-child {\n  padding-bottom: 9px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
